import { IParsedImage } from '@components/typescript';
import styles from '@features/cms/components/collections/FeaturesBlock/FeaturesBlock.styles';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
import GetImageAlt from '@utils/getImageAlt';
type PropsType = {
  blockImage: IParsedImage;
};
const FeaturesBlockImage = ({
  blockImage
}: PropsType) => {
  if (!blockImage.image.desktop) return <></>;
  return <ResponsiveImage image={blockImage.image} blur={blockImage.blur} objectFit="contain" alt={GetImageAlt(blockImage.image)} sx={styles.image} />;
};
export default FeaturesBlockImage;